module.exports = "/img/assigned-empty.a78b0d3f.png";